export default __webpack_public_path__ + "static/media/logo_padrao_alinhado.9859094f.png";